module.exports = __webpack_public_path__ + "media/images/icons/flags/lang-fr-1e2d268904ff404291e780bb229cc0af.svg";